import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store'; 

const rootElement = document.getElementById('root');

// Suppress harmless ResizeObserver errors from triggering the Webpack error overlay
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) resizeObserverErr.style.display = 'none';
    if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = 'none';
  }
});

// Also suppress it from console.error to avoid spam
const _consoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications.')) {
    return;
  }
  _consoleError.apply(console, args);
};

const root = createRoot(rootElement);
root.render(
  <Provider store={store}>
     <PersistGate loading={null} persistor={persistor}>
      <App />
     </PersistGate>
</Provider>,
);

reportWebVitals(console.log);
